import { FormType, InputType, ReactiveDropdownCatalogs } from '@fitogest/reactive-form-builder/interfaces';
import { list } from '@fitogest/reactive-form-builder/utils';
import { TareaAlquilerMaquinariaModel } from '../../../../../../models/tareas/tarea-alquiler-maquinaria.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';

export const maquinaria = list(
    ['...', '0'],
    ['JOFEMESA', '1'],
    ['PRIMOTI', '2'],
    ['TOLLQUICK', '3'],
    ['MALCOP', '4'],
    ['ALQUICESMAR', '5'],
    ['OTROS', '6'],
);

export class TareasAlquilerMaquinariaFormDefinition extends MtoReactiveFormDefinition<TareaAlquilerMaquinariaModel> {
    constructor(type: FormType = FormType.CREATION, model: Partial<TareaAlquilerMaquinariaModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'alquiler',
            header: 'Datos de alquiler de maquinaria',
            database: 'tareas_alquiler_maquinaria',
            signatureFolder: 'alquiler',
            sections: this.getSections(),
            dropdownCatalogs: this.getDropdownCatalogs(),
        });
    }


    private getDropdownCatalogs(): ReactiveDropdownCatalogs {
        return {
            critical: ['id_finca'],
            deferred: ['id_cliente', 'ids_trabajadores'],
            lazy: ['maquina'],
        };
    }

    private getSections(): MtoSectionSpec<TareaAlquilerMaquinariaModel>[] {
        return [
            { name: 'Datos de alquiler de maquinaria', fields: [...this.getDefaultMainFieldSpecs({ includeHours: false, includeMantenimiento: false })] },
            { name: 'Datos de alquiler', fields: [
                this.field('maquina', `Maquinaria`, InputType.DROPDOWN, { data: this.lists.maquinariasAlquiler, width: 3 }),
                this.hourField('hora_inicio', 'Hora inicio'),
                this.field('hora_fin', 'Hora fin', InputType.TIME, { width: 3, defaultValue: this.getDefaultHoraFin() }),
                this.hourTotalField('horas_totales', 'Horas', 'hora_inicio', 'hora_fin'),
            ] },
            this.workerSection('Profesionales'),
            this.workOrderSection(),
            this.observationSection('Observaciones'),
        ];
    }
}
